export enum AccessType {
    Read = 'Read',
    Edit = 'Edit'
}
